export default {
  paymentHistoryTitle: {
    id: 'insurance_services_hub_payment_history_title',
    defaultMessage: 'Payment history',
  },
  succeeded: {
    id: 'insurance_services_hub_payment_history_succeeded_payment',
    defaultMessage: 'Payment',
  },
  chargeback: {
    id: 'insurance_services_hub_payment_history_chargeback_done',
    defaultMessage: 'Chargeback',
  },
  failed: {
    id: 'insurance_services_hub_payment_history_failed',
    defaultMessage: 'Failed payment',
  },
  refunded: {
    id: 'insurance_services_hub_payment_history_refunded',
    defaultMessage: 'Refund',
  },
  seePaymentHistory: {
    id: 'insurance_services_hub_payment_history_see_payment_history',
    defaultMessage: 'See all payment history',
  },
  paymentHistoryDrawerTitle: {
    id: 'insurance_services_hub_payment_history_payment_history_drawer_title',
    defaultMessage: 'Payment history',
  },
}
